'use client'

import { type DetailedHTMLProps, type LiHTMLAttributes, useContext } from 'react'

import cn from 'clsx'

import css from './SidebarNavItem.module.css'
import { ThemeContext } from '@/utils/themeContext'
import { Text } from '@/components/Text/Text'

export interface SidebarNavItemProps
    extends DetailedHTMLProps<LiHTMLAttributes<HTMLLIElement>, HTMLLIElement> {
    active?: boolean
    disabled?: boolean
    onClick?: () => void
    href?: string
    tag?: 'a' | 'button'
}

/**
 * This the styled version of side bar item
 */
export function SidebarNavItem({
    active,
    className,
    children,
    onClick,
    href,
    disabled,
    tag,
    ...rest
}: SidebarNavItemProps) {
    const { theme = 'todoist' } = useContext(ThemeContext)
    const elTag = tag ? tag : href ? 'a' : 'button'
    const elType = tag === 'a' || href ? undefined : 'button'

    return (
        <li className={cn(css.sidebarNavItem, { [css.twist]: theme === 'twist' })} {...rest}>
            <Text
                tag={elTag}
                type={elType}
                size="minor-base"
                weight="medium"
                className={cn(
                    css.sidebarInner,
                    { [css.active]: active, [css[theme]]: theme },
                    className,
                )}
                aria-pressed={!href ? active : undefined}
                disabled={disabled}
                onClick={onClick}
                href={href}
            >
                {children}
            </Text>
        </li>
    )
}
